<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { hanldeLang } from './i18n/index.js'

export default {

  mounted() { 
      hanldeLang()
  }

}
</script>

<style lang="stylus">
body,html
  padding 0
  margin 0
  height 100vh
  width 100vw
  overflow hidden
p
  margin 0

*{
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
</style>
